export enum PackageTypeEnum {
  Installation = 1,
  Transport = 2,
  Visit = 3,
}
